import useWizardFormCtx from "../../ctx-provider/useWizardFormCtx";
import Hunderassen from "../Hunderassen";
import FormBo from "../FormBo";
import StvJaNeinUnbekannt from "../../../../../consumer/form/dto/StvJaNeinUnbekannt";
import useInputSubmitValidator, { generateValidatorId } from "../../../../../form/input/useInputSubmitValidator";
import HundeRasseValidator from "./HundeRasseValidator";
import StringUtil from "../../../../../app/util/StringUtil";
import { useEffect, useState } from "react";
import FormHundBo from "../FormHundBo";
import AutocompleteField from "../../../../cmp/input/AutocompleteField";
import GtmFormularfeldId from "../../../../../gtm/types/GtmFormularfeldId";

export const exportRasse = (bo: FormHundBo) => StringUtil.trim(bo.rasse);
export const exportRasseVersicherbar = (bo: FormHundBo) => bo.rasseVersicherbar;

type Param = {
    index: number // start with 1
}

const VALIDATOR_ID = generateValidatorId("IhrTier-HundeRasse");

const HundeRasse: React.FC<Param> = ({ index }) => {

    // *** Formulardaten werden geladen
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const actuHund = FormBo.selectHund(wizardFormBo.ihrTier, index);

    const [rasse, setRasse] = useState(actuHund.rasse);
    const [rasseVersicherbar, setRasseVersicherbar] = useState(actuHund.rasseVersicherbar);

    // *** Validator wird initialisiert
    const { validationState, fireFieldValidation } = useInputSubmitValidator(VALIDATOR_ID, new HundeRasseValidator(rasse, rasseVersicherbar), index);

    const updateValidationState = (rasse?: string, versicherbar?: StvJaNeinUnbekannt) => {
        fireFieldValidation(new HundeRasseValidator(rasse, rasseVersicherbar));
    }

    // ****************************
    // init
    // ****************************
    useEffect(() => {
        if (!StringUtil.isBlank(rasse)) {
            updateValidationState(rasse, rasseVersicherbar);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const onChange = (value: string) => {
        const option = Hunderassen.find(rasse => rasse.rasse === value);
        const rasse = option ? option.rasse : value;
        const versicherbar = option ? option.versicherbar : StvJaNeinUnbekannt.UNBEKANNT;
        handleOnChange(rasse, versicherbar);
    }

    const handleOnChange = (rasse: string | undefined, versicherbar: StvJaNeinUnbekannt) => {
        setRasse(rasse);
        setRasseVersicherbar(StringUtil.isBlank(rasse) ? undefined : versicherbar);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        updateValidationState(rasse, rasseVersicherbar);

        actuHund.rasse = rasse;
        actuHund.rasseVersicherbar = rasseVersicherbar;
        fireWizardFormBo(wizardFormBo);
    }

    return (
        <>
            <AutocompleteField id="hundeRasse" idGtm={GtmFormularfeldId.hundeRasse} idGtmIndex={index}
                label="Rasse"
                value={rasse}
                options={Hunderassen.map((option) => option.rasse)}
                onInputBlur={onBlur}
                blurOnEnter={true}
                preventSubmitOnEnter={false}
                onInputChange={onChange}
                required={true}
                error={validationState.error}
                helperText={validationState.message}
            />
            {/* 
            <Autocomplete
                id="free-solo-demo"
                freeSolo
                options={Hunderassen.map((option) => option.rasse)}
                onChange={(event: any, option: any | null) => {
                    console.log('onChangeOption(option)', option);
                    onChangeOption(option)
                }}
                renderInput={(params) => (
                    <TextField {...params} label="freeSolo" margin="normal" variant="outlined" />
                )}
            />
*/}

        </>

    );
}

export default HundeRasse;